module.exports = __webpack_public_path__ + "static/media/qm.01f819a5.svg";